import { userInfoSafe } from 'hub-http/userInfo';
export function hasGate(gateName) {
  return userInfoSafe().then(userInfo => userInfo.gates.includes(gateName));
}